import script from "./CustomNotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomNotificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomNotificationModal.vue?vue&type=style&index=0&id=6f450cf7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f450cf7"]])

export default __exports__